var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(3, function(i) {
      return _c("div", [
        _c("h3", [_vm._v("Here is custom component")]),
        _vm._v(" "),
        _vm._m(0, true),
        _vm._v(" "),
        _c("a", { attrs: { href: "https://vuejs.org" } }, [
          _vm._v("https://vuejs.org")
        ])
      ])
    })
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticClass: "img-fluid",
        attrs: { src: "https://vuejs.org/images/logo.png" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5055c67c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5055c67c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Resource/CustomComponent/Normal.vue
// module id = null
// module chunks = 